import { Wordmark } from '@/components/brand/Brand';
/**
 * GlobalFooter — subtle mark shown on every app page + portal page + share
 * link page. Wave 5.9 (build 3): tenant name removed by user request; the
 * tenant belongs in the portal header only. Footer is a fixed KEY-MADE mark.
 *
 * Renders one muted line:  © {year} KEY-MADE · Engineered by KEY-MADE
 *
 * The `tenantName` prop is kept for backwards-compat with existing call
 * sites (SiteOffice, ContractorPortal) but is intentionally ignored.
 */
export default function GlobalFooter({ tenantName: _tenantName, darkMode = false, compact = false }) {
  const year = new Date().getFullYear();

  return (
    <footer
      className={`w-full text-center ${compact ? 'py-2' : 'py-4'} px-4 select-none`}
      data-testid="global-footer"
    >
      <p className={`text-[10px] tracking-wide ${darkMode ? 'text-[#5A5A5A]' : 'text-[#9A9793]'}`}>
        © {year} <Wordmark /> · Engineered by <Wordmark />
      </p>
    </footer>
  );
}
